module.exports = __webpack_public_path__ + "static/media/chopin-footer-3-pl.8cda1e16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chopin-footer-3-pl.png
// module id = 1096
// module chunks = 0